export default __webpack_public_path__ + "media/images/logo-b250-o50-c550bd8dd39445fc620b83cb6abafe6c.png";